<template>
  <div :dir="$functions.currentLangDirection()">
    <b-card
      class="devicesList d-md-block"
      style="overflow-x: hidden;width: 100vw;
            height: calc( 100vh - 50px);
            padding: 0 !important;
            margin: 0 !important;
            top: 0 !important;
            left: 0 !important;
            position: absolute;"
    >
      <v-row style="background: #00abfd;">
        <v-col
          cols="7"
          md="7"
          style="padding-top: 0;padding-bottom: 0px;"
        >
          <v-text-field
            dark
            color="#fff"
            append-icon="mdi-magnify"
            label="جستجو در دستگاه ها"
            class="searchDeviceInput"
            style=""
            @input="filterSearch"
          />
        </v-col>
        <v-col
          cols="5"
          md="5"
          style="padding-right: 0;padding-top: 0;padding-bottom: 0px;"
        >
          <b-button
            v-if="mobile != '09120000000'"
            variant="gradient-light"
            style=" position: absolute;top: 20px;color: #fff;padding-right: 5px;padding-left: 0;"
            class="btn addDeviceBtn"
            @click="onAddDeviceClick()"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            /> {{ $t('Add new device') }}
          </b-button>
        </v-col>
      </v-row>
      <v-row style="padding-top: 0px !important;">
        <v-data-table
          :header-props="{ sortIcon: null }"
          :items="desserts"
          item-key="imei"
          class="elevation-1"
          mobile-breakpoint="0"
          loading
          :loading-text="$t('Loading...')"
          style="font-size: 10px!important;width: 100%;margin-right: 15px;margin-left: 15px;"
          :hide-default-footer="true"
          :hide-default-header="true"
          :page.sync="pageDeviceTable"
          height="calc(100vh - 190px)"
        >
          <template
            v-slot:item="{ item, index }"
          >
            <tr
              :data-id="item._id"
              style="background: #fff;"
              :class="$functions.currentLangDirection()"
            >
              <td colspan="1">
                <div
                  class="row mt-0"
                  style="border-bottom: 1px solid rgb(219 219 219);"
                >
                  <div
                    class="col-2"
                    style="padding: 5px;text-align: center;"
                  >
                    <span
                      v-if="getStatusMovement(item.imei)==='offline'"
                      style="width: 30px;display: block;border-radius: 30px;background: gray;height: 30px;line-height: 30px;padding-right: 2px;"
                    >
                      <v-icon
                        size="20"
                        color="#fff"
                        style="padding-left: 3px;"
                      >mdi-car-side</v-icon>
                    </span>
                    <span
                      v-else-if="getStatusMovement(item.imei) === 'move'"
                      style="width: 30px;display: block;border-radius: 30px;background: green;height: 30px;line-height: 30px;padding-right: 2px;"
                    >
                      <v-icon
                        size="20"
                        color="#fff"
                        style="padding-left: 3px;"
                      >mdi-car-side</v-icon>
                    </span>
                    <span
                      v-else-if="getStatusMovement(item.imei) === 'on'"
                      style="width: 30px;display: block;border-radius: 30px;background: #d2a907;height: 30px;line-height: 30px;padding-right: 2px;"
                    >
                      <v-icon
                        size="20"
                        color="#fff"
                        style="padding-left: 3px;"
                      >mdi-car-side</v-icon>
                    </span>
                    <span
                      v-else
                      style="width: 30px;display: block;border-radius: 30px;background: #e76c6c;height: 30px;line-height: 30px;padding-right: 2px;"
                    >
                      <v-icon
                        size="20"
                        color="#fff"
                        style="padding-left: 3px;"
                      >mdi-car-side</v-icon>
                    </span>
                  </div>
                  <div
                    class="col-6"
                    style="padding: 5px;text-align: right;"
                    @click="mapClick(item.imei)"
                  >
                    <span style="width: 100%;display: block;">
                      {{ item.title }}
                    </span>
                    <div style="font-size: 11px;color: gray;">
                      <span />
                      <span style="">
                        {{ item.imei }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-4"
                    style="padding: 5px;text-align: center;"
                  >
                    <div style="width: 100%;display: block;">
                      <span
                        v-if="getPopupInfo(item.imei).expire"
                        class="expired-base1"
                        style="font-size: 0.7rem;color: #c00;font-weight: bold;"
                      >
                        {{ $t('Expired') }}.
                      </span>
                      <span
                        v-else
                        style="font-size: 0.6rem;"
                      >
                        {{ sinceFromDevice(item.imei) }}
                      </span>
                    </div>
                    <div style="font-size: 11px;color: gray;">
                      <b-button
                        class="btn btn-sm"
                        variant="outline-link"
                        style="padding: 0px;width: 100%;font-size: 0.6rem;color: #666;"
                        @click="onSendCommand(item.imei, 'updatePosition')"
                      >
                        <span style="">
                          <v-icon
                            size="14"
                          >
                            mdi-reload
                          </v-icon>
                        </span>
                        <span style="">
                          {{ $t('Update') }}
                        </span>
                      </b-button>
                    </div>
                  </div>
                </div>
                <div
                  class="row "
                  style="height: 50px;"
                >
                  <div
                    class="col-4"
                    style="padding: 5px;text-align: center;"
                    @click="detailClick(item.imei)"
                  >
                    <v-icon
                      class="handle grab"
                      size="18"
                      color="#3597ef"
                    >
                      mdi-file-document-outline
                    </v-icon>
                    <span style="font-size: 11px;color: gray;">
                      {{ $t('Details') }}
                    </span>
                  </div>
                  <div
                    class="col-4"
                    style="padding: 5px;text-align: center;"
                    @click="commandClick(item.imei)"
                  >
                    <v-icon
                      class="handle grab"
                      size="18"
                      color="#3597ef"
                    >
                      mdi-cog
                    </v-icon>
                    <span style="font-size: 11px;color: gray;">
                      {{ $t('Commands') }}
                    </span>
                  </div>
                  <div
                    class="col-4"
                    style="padding: 5px;text-align: center;"
                    @click="historyClick(item.imei)"
                  >
                    <v-icon
                      class="handle grab"
                      size="18"
                      color="#3597ef"
                    >
                      mdi-map-marker-path
                    </v-icon>
                    <span style="font-size: 11px;color: gray;">
                      {{ $t('Movement history') }}
                    </span>
                  </div>
                </div>

              </td>

            </tr>
          </template>

          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>

      </v-row>
    </b-card>

    <div
      v-show="pageCountDeviceTable >1"
      class="text-center px-1 align-center"
      style="    position: absolute;
    bottom: 60px;
    right: 0px;
    width: 100%;
    z-index: 999;"
      dir="ltr"
      wrap
    >
      <v-row
        style="    background: rgb(255, 255, 255);"
      >
        <v-col
          cols="12"
          md="12"
        >
          <v-pagination
            v-model="pageDeviceTable"
            :total-visible="7"
            circle
            :length="pageCountDeviceTable"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody,
} from 'bootstrap-vue'
import Vue from 'vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import router from '@/router'
import UserService from '@/services/user.service'
import deviceService from '@/services/device.service'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BLink, BButton, BCard, BCardText, BCardBody,
  },
  data() {
    return {
      mobile: getUserData().mobile,
      desserts: Vue.prototype.$devices,
      pageDeviceTable: 1,
      itemsPerPage: 10,
      search: '',
      items: [
        { title: 'Change the name of the car', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'Change the type of car', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'Change the sim', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'Send device settings', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  computed: {
    totalRecords() {
      return this.desserts.length
    },
    pageCountDeviceTable() {
      return Math.ceil(this.totalRecords / this.itemsPerPage)
    },
    headers() {
      return [
        {
          text: 'Category',
          align: 'start',
          sortable: false,
          value: 'category',
          width: '45px',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
          width: '50%',
        },
        {
          text: 'Communication status',
          align: 'start',
          value: 'onlineStatus',
        },
        {
          text: 'Movement status',
          align: 'start',
          value: 'serverStatus',
        },
        {
          text: 'Satellite status',
          align: 'start',
          value: 'serverInfo',
        },
        {
          text: 'Options',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  created() {
    this.QXUpdateFirebaseData()
  },
  mounted() {
    this.$root.$on('forceUpdate', payload => {
      if (payload.event === 'socket.devicePosition') {
        if ('imei' in payload.data) {
          this.$forceUpdate()
        }
      }
    })
  },
  methods: {
    onSendCommand(imei, commandName) {
      deviceService.sendCommand({
        imei,
        commandName,
      }).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: this.$t('An update request sent'),
                icon: 'XIcon',
                variant: 'success',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    detailClick(imei) {
      Vue.prototype.$selectDeviceDetail = imei
      this.$emit('on-change-page', 'home', 'detail', imei)
    },
    commandClick(imei) {
      Vue.prototype.$selectCommand = imei
      this.$emit('on-change-page', 'home', 'command', imei)
    },
    mapClick(imei) {
      // console.log(imei)
      this.$emit('on-change-page', 'home', 'map', imei)
    },
    historyClick(imei) {
      this.$emit('on-change-page', 'home', 'history', imei)
    },
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    getStatusMovement(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.getStatusMovement(index)
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(index))
    },
    doFillDevices() {
      this.desserts = Vue.prototype.$devices
    },
    filterSearch(value) {
      this.desserts = Vue.prototype.$devices.filter(item => value.toLowerCase()
        .split(' ')
        .every(v => (item.imei || '').toLowerCase()
          .includes(v) || (item.title || '').toLowerCase()
          .includes(v)))
    },
    filterPerfectMatch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },

    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    sinceFromDevice(imei) {
      const d = this.getPopupInfo(imei)
      if (!d || !d.serverInfo) return this.$t('Unknown')
      const servertime = d.serverInfo.servertime || 0
      const statusServertime = d.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    buildLogoUrl(category) {
      try {
        return require(`@/assets/images/pins/cars/${this.options[category].src}.png`)
      } catch (e) {
        return require('@/assets/images/pins/cars/car.png')
      }
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
  },
}
</script>
<style>
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

[dir=ltr] .v-pagination__navigation {
  transform: rotateY(180deg);
}

[dir=rtl] .devicesList{
  top: 50px;
  width: 100%;
}
[dir=rtl] .devicesList .card-body{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 12px !important;
}
[dir=rtl] .devicesList {
  height: 100vh;
}
[dir=rtl] .devicesList {
  z-index: 998;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}
.devicesList .card, .devicesList .card-body {
  background: #f7f7f7;
}
[dir="rtl"] .devicesList {
  height: calc(100% - 50px);
  top: 0px;
  z-index: 99;
}
.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}
.devicesList .v-data-table>.v-data-table__wrapper>table{
  border-collapse: separate!important;    border-spacing: 0 0.8em;    background: #f7f7f7;
}
.devicesList .v-data-table__wrapper{
  padding-bottom: 35px;
}
</style>
